import React, {useState, useEffect} from 'react';
import { Link, useLocation, Outlet} from 'react-router-dom';
import Slider from "react-slick";
import useWindowSize from '../../hooks/useWindowSize';
import IconClose from '../common/asset/images/icon-close.svg'; 
import IconSearch from '../common/asset/images/icon-search.svg';
import IconList from '../common/asset/images/icon-list.svg';
import IconListActive from '../common/asset/images/icon-list-active.svg';
import IconGrid from '../common/asset/images/icon-grid.svg';
import IconGridActive from '../common/asset/images/icon-grid-active.svg';
import {useSelector, useDispatch} from 'react-redux';
import allActions from '../../actions';

const dataTabs = [
    {to: '/airdrop/upcoming', title: 'Upcoming'},
    {to: '/airdrop/ongoing', title: 'Opening'},
    {to: '/airdrop/completed', title: 'Ended'},
    // {to: '/ino/bought', title: 'Bought'}, 
];  

const Airdrop = () => {
    const dispatch = useDispatch();
    const [isOpenTab, setIsOpenTab] = useState(false); 
    const [bannerArr, setBannerArr] = useState([]);  
    const displayView = localStorage.getItem("airdropView");
    const [isDisplay, setIsDisplay] = useState(displayView === null ? 'list' : displayView);
    let location = useLocation();
    const size = useWindowSize();
    const sizeTablet = 767;
    let myPathname = location.pathname;
    const sep = /\//;
    let isPathname = myPathname.split(sep);
    
    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        dots: true
    };
    
    const displayList = () => {
        setIsDisplay('list');
        localStorage.setItem("airdropView", "list");
    }
    const displayGrid = () => {
        setIsDisplay('grid');
        localStorage.setItem("airdropView", "grid");
    } 

    useEffect(() => { 
        dispatch(allActions.airdropAction.getBanner({position: "TOP", type: "AIRDROP"}, (res) => { 
            setBannerArr(res)
          }));
    }, [dispatch]);
     

    const elmMenuTabs = dataTabs.map((item,key) => {
        let myTab = item.to;
        let isTabName = myTab.split(sep);  

        return(
            <li key={key} className={isPathname[2]===isTabName[2] ? 'is-active' : ''}>
                <Link onClick={() => setIsOpenTab(false)} to={item.to}>{item.title}</Link>
                {item.ask && <div className="c-tabs__ask">
                    {item.ask}
                    <p>Claimable includes projects that will be claimed in the current month</p>
                </div>}
            </li>
        );
    });  
    
    return(
        <div className="p-launchpad p-airdroplist">
            <div className="c-sliderAirdrop">
                <Slider {...settings}>
                    {bannerArr && bannerArr.length>0 && bannerArr.map((e,i)=>(
                        <div key={i.toString()} className="c-sliderAirdrop__item">
                           {size.width <= sizeTablet ? <img src={e?.bannerMobile} alt="" /> : <img src={e?.banner} alt="" />  }
                        </div>
                    ))} 
                </Slider>
            </div>
            <div className='p-airdroplist__box'>  
            <div className="p-airdroplist__head">
                <div className="p-airdrop__head">
                    <h3>Bounty/ Airdrop</h3> 
                    <div className="airdrop-tool">
                        {isPathname[2] === "completed" ? <div className="p-stake__display">
                            <button onClick={() => displayList()}><img src={isDisplay==='list' ? IconListActive : IconList} alt="List" /></button>
                            <button onClick={() => displayGrid()}><img src={isDisplay==='grid' ? IconGridActive :IconGrid} alt="Grid" /></button>
                        </div>: null}  
                    </div> 
                </div> 
            </div>
            {isOpenTab ? <div className="c-bgSP"></div> : ''}
            <div className="c-tabs">
                <div className="c-tabs-airdrop">
                    {size.width <= sizeTablet ? <div className="c-tabs__navSP" onClick={() => setIsOpenTab(true)}>{isPathname[2]}</div> : ''}
                    <ul className={`c-tabs__nav ${isOpenTab ? 'is-open' : ''}`}>
                        {size.width <= sizeTablet ? <li className="is-close">Status<span onClick={() => setIsOpenTab(false)}><img src={IconClose} alt="Close" /></span></li> : ''}
                        {elmMenuTabs}
                    </ul> 
                </div> 
                {isPathname[2] === "completed" ? (
                    <>
                        {isDisplay === "list" ?<div className="c-tabs__content airdrop-list is-changeAirdrop">
                            <Outlet />
                        </div>: <div className="c-tabs__content airdrop-grid is-changeAirdrop">
                            <Outlet/>
                        </div>} 
                    </>
                ) : (
                    <div className="c-tabs__content airdrop-grid is-changeAirdrop">
                        <Outlet/>
                    </div>
                )}
                
            </div>
            </div>
        </div>
    );
};

export default Airdrop;